import { createContext, useContext } from 'react'

export const FiltersContext = createContext({
  filters: [],
  roles: null,
  locations: null,
  skills: null,
  setFilterValues: () => {},
})
export const FiltersProvider = FiltersContext.Provider
export const FiltersConsumer = FiltersContext.Consumer
export const useFilters = () => {
  return useContext(FiltersContext)
}
